import {createContext, useState} from 'react';
import {parseConfigFromPage} from '../helpers/parseConfigFromPage';
import {useMountEffect} from '../useMountEffect';
import {configureSentry} from '../helpers/sentry';
import {Config} from '../../generated/types';

export const defaultConfig: Config = {
  parentOrigin: '',
  stripeThirdPartyBaseUrl: '',
  audience: 'express',
  entrypoint: 'express_support_site',
  featureFlags: {
    useConversationsFramework: false,
    enableUniversalHelp: false,
    universalHelpDrawerEnabled: false,
    universalHelpDontUseDashboardEmailForm: false,
    universalHelpUseNewDesign: false,
    universalHelpUseDotComDesign: false,
    enableAnonSupportConversationsEndpoints: false,
    enableSupportConversationsEnforceAuth: false,
    enableSupportConversationsLivemodeHeader: false,
    universalHelpDotComFeedbackButtons: false,
    universalHelpDotComNoLlm: false,
    universalHelpDotComCsf: false,
    universalHelpMessagesTopAnchored: false,
    universalHelpEncourageMoreDetailFromUserMse5042: false,
    universalHelpFileUploadProvider: false,
    universalHelpUseInlineRacEmailForm: false,
    racInProgressV2: false,
    consolidatedConversationsLiveAnswersRow: false,
    irIndigoCollectFixes: false,
  },
  experiments: {
    supportFrontendTestExperiment: {
      variant: 'control',
      experimentName: 'support_frontend_text_experiment',
    },
  },
  revision: '',
  publicSentryDsn: '',
  urls: {
    supportSite: '',
    uploadsHost: '',
  },
  surfaceLoadId: '1234',
  token: '',
  livemode: false,
  visitor: {
    id: 'invalid-visitor',
    sessionType: 'anonymous',
    emailConfirmed: false,
  },
  resumeVisibilityState: 'open',
};

export const ConfigContext = createContext<Config>(defaultConfig);

interface Props {
  children: JSX.Element;
}

export function ConfigProvider({children}: Props) {
  const [config] = useState<Config>(
    () => parseConfigFromPage() || defaultConfig,
  );

  const {visitor, revision, publicSentryDsn} = config;

  useMountEffect(() => {
    if (publicSentryDsn) {
      configureSentry(publicSentryDsn, revision, visitor);
    }
  });

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
}
